import { render, staticRenderFns } from "./otherFees.vue?vue&type=template&id=a18295d6&scoped=true&"
import script from "./otherFees.vue?vue&type=script&lang=js&"
export * from "./otherFees.vue?vue&type=script&lang=js&"
import style0 from "./otherFees.vue?vue&type=style&index=0&id=a18295d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18295d6",
  null
  
)

export default component.exports